import CardDesa from 'components/CardDesa';
import React, { useContext } from 'react'
import IcLg from 'assets/icons/ic-lg.png'
import ModalFilter from 'components/ModalFilter';
import { useState } from 'react';
import { useCallback } from 'react';
import { filterDesaLandingPage, getDesaLandingPage, searchDesaLandingPage } from 'services/apiRoutes';
import { useEffect } from 'react';
import SkeletonMaincard from 'skeletons/SkeletonMaincard';
import { userContext } from 'Context/userContext';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';


export default function Joined() {
  const navigate = useNavigate()
  const [loading,setLoading]=useState(false);
  const dataContext = useContext(userContext);
  const [prov, setProv] = useState();
  const [kab, setKab] = useState();
  const [kec, setKec] = useState();
  const [keyword,setKeyword]=useState();
  const [desa,setDesa]=useState();

  const desaAPI = useCallback(async()=>{
    setLoading(true);
    const res = await getDesaLandingPage();
    if (res.error) {
      setLoading(false);
      return res.message
    }
    setLoading(false);
    const { data } = res.data;
    setDesa(data);
  },[]);

  const filterAPI = useCallback(async(prov,kab,kec)=>{
    setLoading(true)
    const res = await filterDesaLandingPage(prov,kab,kec)
    if (res.error) {
      setLoading(false)
      toast.error(res.message)
      return res.message
    }else{
      const {data} = res.data;
      setDesa(data);
      toast.success(res.message)
      setLoading(false);
    }
  },[])

        const searchKegAPI = useCallback(async (keyword) => {
          setLoading(true);
          const res = await searchDesaLandingPage(keyword);
          if (res.error) {
            setLoading(false)
            setDesa([])
            return res.message;
          } else {
            setLoading(false);
            const { data } = res.data;
            setDesa(data);
          }
        }, []);

        // const seacrhKeg = () => {
        //   searchKegAPI(keyword);
        // };

        const handleKeypress = (e) => {
          if (e.key === "Enter") {
            searchKegAPI(keyword);
          }
        };

  useEffect(() => {
    desaAPI();
  }, [desaAPI,keyword,prov,kab,kec]);

  return (
    <div className="relative px-5 pb-32 space-y-16 bg-transparent wrapper xl:px-99">
      <h1 className="text-3xl font-bold text-center">
        Lihat mereka yang sudah bergabung menjadi Geulanggang-Panah
      </h1>
      <div>
        <p className="mx-2 text-sm font-semibold">Search</p>
        <div className="items-center space-y-5 md:space-x-5 md:space-y-0 searchWrapper md:flex">
          <input
            placeholder="Cari desa"
            onKeyPress={handleKeypress}
            onChange={(e) => setKeyword(e.target.value)}
            type="text"
            className="w-full px-3 py-3 mt-2 mr-4 border seacrh rounded-2xl focus:ring-2 focus:ring-primary focus:border-none focus:outline-none"
          />
          {desa?.length !== 0 ? null : (
            <h1 className="font-bold md:hidden">{`"${keyword}" Tidak Ditemukan`}</h1>
          )}
          <ModalFilter
            onClick={() => filterAPI(prov, kab, kec)}
            onChangeProv={(e) => {
              setProv(e.target.value);
              dataContext?.setProv(e.target.value);
            }}
            onChangeKab={(e) => {
              setKab(e.target.value);
              dataContext?.setKab(e.target.value);
            }}
            setValue={dataContext?.kab}
            onChangeKec={(e) => {
              setKec(e.target.value);
              dataContext?.setKec(e.target.value);
            }}
          />
        </div>
        {desa?.length !== 0 ? null : (
          <h1 className="hidden mt-2 font-bold md:block">{`"${keyword}" Tidak Ditemukan`}</h1>
        )}
      </div>
      <div className="space-y-8 md:space-y-0 lg:grid-cols-3 md:grid-cols-2 md:grid gap-28 cardWrapper mt-11">
        {!loading
          ? desa?.map((item, index) => (
              <CardDesa
                logo={IcLg}
                name={item?.nama}
                key={index}
                onClick={() => navigate(`/${item?.slug_desa}`)}
              />
            ))
          : [1, 2, 3, 4, 5, 6].map((i) => <SkeletonMaincard key={i} />)}
      </div>
    </div>
  );
}
